import React, {useContext, useEffect, useRef, useState} from 'react';
import {Avatar, Stack, Tooltip} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import {Images} from '../../../common/Assets/Images';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import {userProfileUploads, usersProfileAPi} from '../../../services/UserServices';
import InviteUsers from '../UserManagement/InviteUsers';
import { serialize as o2f } from "object-to-formdata";
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext} from '../../../store';

export default function AdminProfile() {
  const dispatch = useContext(DispatchContext);
  const [user, setUser] = useState({});
  const [open, setOpen] = useState(false);
  const userId = user?.id;
  const userData = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    getUser();
  },[]);

  const getUser = () => {
    usersProfileAPi('get').then(res => {
      setUser(res?.data);
    })
  }

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleProfileUpload = ({target: {files: [file]}}) => {
    userProfileUploads("put", userId, null, o2f({ photo: file })).then((res) => {
      let storedData = JSON.parse(localStorage.getItem('user'));
      storedData.profile.photo = res?.data?.profile?.photo;
      localStorage.setItem('user', JSON.stringify(storedData));
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {
            isNotify: true,
            severity: "success",
            message: "Profile photo updated successfully",
          },
        });
      }
    );
    getUser();
  };

  return (
    <Stack
      padding={2}
      bgcolor="#f7f7fa"
      minHeight={'100vh'}
      alignItems={'center'}
    >
      <Stack sx={{width: {lg: '44%', md: '48%', sm: '50%', xs: '100%'}}}>
        <Typography variant={'h5'} component={'h2'} fontWeight={700}>
          Profile
        </Typography>
        <Stack
          marginTop={4}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Stack
            flexDirection={'row'}
            alignItems={'center'}
            position={'relative'}
          >
            <IconButton className={'box-shadow-3D'}
              sx={{p: 1, bgcolor: '#fff', '&:hover': {bgcolor: '#b3b6b6'}}}>
              <img
                src={userData?.profile?.photo || Images.logoWhite}
                style={{width: 100, height: 100, borderRadius: 100}}
                alt={'profile'}
              />
            </IconButton>
            <Avatar
              aria-label="upload picture"
              component="label"
              sx={{
                width: 30,
                height: 30,
                cursor: 'pointer',
                position: 'absolute',
                left: '24%',
                bottom: '1%',
              }}
            >
              <input
                hidden
                accept="image/jpeg, image/jpg, image/png"
                id="icon-button-file"
                type="file"
                onChange={handleProfileUpload}
              />
              <CameraAltIcon fontSize={'small'}/>
            </Avatar>
            <Box marginLeft={2}>
              <Typography variant={'button'} fontWeight={700}>
                {user?.first_name} &nbsp;
                <span
                  style={{
                    color: '#616b88',
                    textTransform: 'capitalize',
                    fontSize: 14,
                  }}
                >
                   ({user?.roles?.[0]?.description})
                  </span>
              </Typography>
              <Typography className={'font-14'}>{user?.museums?.[0]?.name}</Typography>
            </Box>
          </Stack>
        </Stack>
        <Paper
          elevation={0}
          sx={{
            mt: 2,
            py: {lg: 3, md: 3, sm: 3, xs: 2},
            px: {lg: 6, md: 6, sm: 6, xs: 3},
            boxShadow: '0 .1rem 0.7rem rgba(0, 0, 0, 0.02)',
            borderRadius: 2,
          }}
        >
          <Box paddingBottom={2}>
            <Typography variant={'subtitle2'} component={'h2'}>
              Full Name
            </Typography>
            <Typography
              variant={'subtitle1'}
              component={'h2'}
              fontWeight={700}
            >
              {user?.first_name}&nbsp;{user?.last_name}
            </Typography>
          </Box>
          <Box paddingBottom={2}>
            <Typography variant={'subtitle2'} component={'h2'}>
              Employee Id
            </Typography>
            <Typography
              variant={'subtitle1'}
              component={'h2'}
              fontWeight={700}
            >
              {user?.emp_id || '-'}
            </Typography>
          </Box>
          <Box paddingBottom={2}>
            <Typography variant={'subtitle2'} component={'h2'}>
              CID
            </Typography>
            <Typography
              variant={'subtitle1'}
              component={'h2'}
              fontWeight={700}
            >
              {user?.cid || '-'}
            </Typography>
          </Box>
          <Box paddingBottom={2}>
            <Typography variant={'subtitle2'} component={'h2'}>
              Email Address
            </Typography>
            <Typography
              variant={'subtitle1'}
              component={'h2'}
              fontWeight={700}
            >
              {user?.email}
            </Typography>
          </Box>
          <Box paddingBottom={2}>
            <Typography variant={'subtitle2'} component={'h2'}>
              Phone Number
            </Typography>
            <Typography
              variant={'subtitle1'}
              component={'h2'}
              fontWeight={700}
            >
              {user?.phone || '-'}
            </Typography>
          </Box>
          <Box paddingBottom={2}>
            <Typography variant={'subtitle2'} component={'h2'}>
              Agency
            </Typography>
            <Typography
              variant={'subtitle1'}
              component={'h2'}
              fontWeight={700}
            >
              {user?.profile?.agency || '-'}
            </Typography>
          </Box>
          <div align={'right'}>
            <IconButton className={'box-shadow-3D'}
              sx={{bgcolor: '#e1e1e1', '&:hover': {bgcolor: '#c2bfbf'}}}
            >
              <Tooltip title={'Edit Profile'} className={'hand-cursor'}>
                <EditIcon sx={{color: '#fff'}} onClick={handleOpen}/>
              </Tooltip>
            </IconButton>
          </div>
        </Paper>
      </Stack>
      {open &&
      <InviteUsers open={open} handleAction={handleClose} userId={userId} editProfile={true}/>}
    </Stack>
  );
}